import { useCallback, useState } from 'react';

import type { Period, PeriodPreset, SteppablePreset } from '@/helpers';

import { periodForPreset, presetPeriod } from '@/helpers';

export type PeriodFilter = {
  period: Period;
  activePreset: PeriodPreset;
  onPresetSelect: (preset: PeriodPreset) => void;
  onAnchorChange: (date: Date) => void;
  onFromChange: (value: string) => void;
  onTillChange: (value: string) => void;
};

export const usePeriodFilter = (
  initialPreset: SteppablePreset,
): PeriodFilter => {
  const [activePreset, setActivePreset] = useState<PeriodPreset>(initialPreset);
  const [period, setPeriod] = useState(() => presetPeriod(initialPreset));

  const onPresetSelect = useCallback((preset: PeriodPreset) => {
    // `custom` keeps the current range as the editable starting point.
    if (preset !== 'custom') {
      setPeriod(presetPeriod(preset));
    }
    setActivePreset(preset);
  }, []);

  const onAnchorChange = useCallback(
    (date: Date) => {
      if (activePreset === 'custom') {
        return;
      }
      setPeriod(periodForPreset(activePreset, date));
    },
    [activePreset],
  );

  const onFromChange = useCallback((value: string) => {
    setPeriod((prev) => ({ ...prev, from: value }));
  }, []);

  const onTillChange = useCallback((value: string) => {
    setPeriod((prev) => ({ ...prev, till: value }));
  }, []);

  return {
    period,
    activePreset,
    onPresetSelect,
    onAnchorChange,
    onFromChange,
    onTillChange,
  };
};
